// extracted by mini-css-extract-plugin
export var cell = "_5q-4";
export var headerCell = "_5q-2";
export var rowHeader = "_5q-3";
export var table = "_5q-1";
export var tableContainer = "_5q-0";